var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 39,
    viewBox: "0 0 54 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1213 0.87868C18.2929 2.05025 18.2929 3.94975 17.1213 5.12132L13.2426 9H39C47.2843 9 54 15.7157 54 24C54 32.2843 47.2843 39 39 39H3C1.34315 39 0 37.6569 0 36C0 34.3431 1.34315 33 3 33H39C43.9706 33 48 28.9706 48 24C48 19.0294 43.9706 15 39 15H13.2426L17.1213 18.8787C18.2929 20.0503 18.2929 21.9497 17.1213 23.1213C15.9497 24.2929 14.0503 24.2929 12.8787 23.1213L3.87868 14.1213C2.70711 12.9497 2.70711 11.0503 3.87868 9.87868L12.8787 0.87868C14.0503 -0.292893 15.9497 -0.292893 17.1213 0.87868Z",
    fill: "var(--ncap-300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return-icon.390298b00919c7ef4edd024145f929df.svg";
export { ForwardRef as ReactComponent };